export const GET_LOGO_FOOTER = "GET_LOGO_FOOTER"
export const GET_LOGO_FOOTER_SUCCESS = "GET_LOGO_FOOTER_SUCCESS"
export const GET_LOGO_FOOTER_FAIL = "GET_LOGO_FOOTER_FAIL"